import { render } from "./DatosAcceso.vue?vue&type=template&id=5a80c6da"
import script from "./DatosAcceso.vue?vue&type=script&lang=js"
export * from "./DatosAcceso.vue?vue&type=script&lang=js"

import "./DatosAcceso.vue?vue&type=style&index=0&id=5a80c6da&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__